const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["sahil", "sahil mund", "sahil mund"],
	},

	{
		page: "about",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["sahil", "sahil mund", "sahil mund"],
	},

	{
		page: "articles",
		description:
			"i am passionate about programming and i love to write about it.",
		keywords: ["sahil", "sahil mund", "sahil mund"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["sahil", "sahil mund", "sahil mund"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["sahil", "sahil mund", "sahil mund"],
	},
];

export default SEO;
